import React from 'react';
import Icon from '../../../components/AppIcon';

const GymStatistics = ({ statistics }) => {
  const stats = [
    {
      label: 'Total Gyms',
      value: statistics?.totalGyms || 0,
      icon: 'Building2',
      color: 'var(--color-primary)',
      bgColor: 'var(--color-primary)15'
    },
    {
      label: 'Active Gyms',
      value: statistics?.activeGyms || 0,
      icon: 'CheckCircle',
      color: 'var(--color-success)',
      bgColor: 'var(--color-success)15'
    },
    {
      label: 'Inactive Gyms',
      value: statistics?.inactiveGyms || 0,
      icon: 'XCircle',
      color: 'var(--color-error)',
      bgColor: 'var(--color-error)15'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {stats?.map((stat, index) => (
        <div key={index} className="card">
          <div className="flex items-center gap-4">
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: stat?.bgColor }}
            >
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-3xl font-heading font-bold text-foreground">{stat?.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GymStatistics;
